import { Entity, formatTicker, mapAssetClass } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FlagIcon } from '~/components/flag-icon/FlagIcon';
import { TruncateTooltip } from '~/components/truncate-tooltip/TruncateTooltip';

import * as S from './EntityDropdownItem.styles';

export const EntityDropdownItem = ({
  entity,
  isActive,
  isFocused,
}: {
  entity: Entity;
  isActive: boolean;
  isFocused: boolean;
}) => {
  const { t } = useTranslation(['analyze']);
  const { sub_class } = mapAssetClass(entity);

  return (
    <S.StyledDropdownListItem
      label={
        <S.Root>
          <S.LeftWrapper>
            <S.StyledAssetLogoContainer size={32} entity={entity} />
            <S.TitleAndSubtitleWrapper>
              <S.TickerLabel>{formatTicker(entity)}</S.TickerLabel>
              <TruncateTooltip
                text={entity.name}
                truncatedLabelWrapper={<S.NameLabel>{entity.name}</S.NameLabel>}
                fallbackLabel={<S.NameLabel>{entity.name}</S.NameLabel>}
                atLength={40}
              />
            </S.TitleAndSubtitleWrapper>
          </S.LeftWrapper>
          <S.RightWrapper>
            <S.ExchangeAndClassWrapper>
              <S.ExchangeLabel>
                {entity.exchange.code.toUpperCase()}
              </S.ExchangeLabel>
              {sub_class && (
                <S.AssetClassLabel>
                  {t(`analyze:assetSubClass.${sub_class}`)}
                </S.AssetClassLabel>
              )}
            </S.ExchangeAndClassWrapper>
            <FlagIcon
              countryCode={entity.trading_country?.long}
              variant="circular"
              customSize={24}
            />
          </S.RightWrapper>
        </S.Root>
      }
      isActive={isActive}
      isFocused={isFocused}
    />
  );
};
